export default __webpack_public_path__ + "static/media/Pillar_Bottom.256.398173d6.png";